import { getISOWeek, getYear, subWeeks } from "date-fns";

export function getCurrentWeekOfYear() {
  const now = new Date();

  const year = getYear(now);
  const week = getISOWeek(now);

  return { week, year };
}

export function getPreviousWeekOfYear() {
  const now = new Date();
  const prevWeek = subWeeks(now, 1);

  const year = getYear(prevWeek);
  const week = getISOWeek(prevWeek);

  return { week, year };
}
